import { createContext, useContext } from 'react';

import type { LEARNING_GOAL_OPTIONS_TYPE } from 'bundles/onboarding-common/constants';

export type OnboardingLearningGoalContextType = {
  /**
   * The current learning goal
   */
  learningGoal: LEARNING_GOAL_OPTIONS_TYPE | null;
};

const OnboardingLearningGoalContext = createContext<OnboardingLearningGoalContextType | null>(null);

export const useOnboardingLearningGoal = () => {
  const context = useContext(OnboardingLearningGoalContext);

  if (!context) {
    throw new Error('useOnboardingLearningGoal must be used within a OnboardingLearningGoalProvider');
  }

  const { learningGoal } = context;

  return {
    learningGoal,
  };
};

export default OnboardingLearningGoalContext;
